/**
 * The two letters an avatar shows for a person: the first letters of the
 * first two words of their name ("Hai Tran" → HT), else the first two letters
 * of what there is (a one-word name, or the email's local part: "htran" → HT).
 * Blank while nothing is known yet, so a loading avatar shows nothing, not "?".
 */
export function initialsFor(name?: string | null, email?: string | null): string {
  const words = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  const base = words[0] || String(email || '').split('@')[0];
  return base.slice(0, 2).toUpperCase();
}
